import {Model, ModelMixin} from '../../common/model.class';
import {Address} from '../../common/values/address.class';
import {InstitutionContact} from '../common/values/institution-contact.class';
import {AttendanceDuration} from '../common/values/attendance-duration.class';
import moment = require('moment');
import Moment = moment.Moment;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class OtherEducation extends ModelMixin() implements Model<OtherEducation> {

    TYPE = OtherEducation;

    institution?: string;
    contact: InstitutionContact = new InstitutionContact();
    address: Address = new Address();
    major?: string;
    degreeAwarded?: boolean;
    graduationDate?: Moment;
    attendance: AttendanceDuration = new AttendanceDuration();

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.graduationDate) jsonData.graduationDate = moment(jsonData.graduationDate);
        if (jsonData.attendance) jsonData.attendance = new AttendanceDuration(jsonData.attendance);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/other/other-education.model.ts